import React from "react";
import PropTypes from "prop-types";
import clsx from "classnames";
import { BsSearch } from "react-icons/bs";
import { enums } from "../../enums";
import "./style.scss";

const TextField = ({
  type,
  name,
  id,
  label,
  placeholder,
  value,
  labelClassName,
  containerClassName,
  state,
  rows,
  className,
  style,
  disabled = false,
  hasError,
  required,
  startIcon,
  endIcon,
  onChange,
  maxLength,
  searchField,
  handleSearchClick,
  size,
  ...rest
}) => {
  const textFieldBaseClass = rows ? "pm-textarea" : "pm-textfield";

  const getTextfieldWithIconClassName = () => {
    if (startIcon && endIcon) return "start-end-icon-textfield";
    if (startIcon) return "start-icon-texfield";
    if (endIcon || searchField) return "end-icon-texfield";
  };

  const textFieldClasses = clsx(
    textFieldBaseClass,
    `${textFieldBaseClass}--${state}`,
    getTextfieldWithIconClassName(),
    `${hasError ? `${textFieldBaseClass}--error` : ""}`,
    `${size ? `${textFieldBaseClass}--${size}` : ""}`,
    className
  );

  const labelBaseClass = "pm-label";
  const labelClasses = clsx(labelBaseClass, labelClassName);

  return (
    <div
      className={`form-group ${containerClassName ? containerClassName : ""}`}
    >
      {label && (
        <label htmlFor={name} className={labelClasses}>
          {label}
          {required && (
            <span style={{ marginLeft: ".2rem" }} className="font-danger">
              *
            </span>
          )}
        </label>
      )}

      {rows ? (
        <textarea
          id={id}
          name={name}
          value={value}
          placeholder={placeholder}
          className={textFieldClasses}
          style={style}
          disabled={disabled}
          rows={rows}
          onChange={onChange}
          {...rest}
        ></textarea>
      ) : (
        <div className="pm-textfield--container">
          <span className="pm-textfield--starticon">{startIcon}</span>
          <input
            type={type}
            id={id}
            name={name}
            value={value}
            placeholder={placeholder}
            className={textFieldClasses}
            style={style}
            disabled={disabled}
            maxLength={maxLength}
            required
            onChange={onChange}
            {...rest}
          />
          <span
            className={`pm-textfield--endicon ${
              size === "sm" ? "pm-textfield--endicon--sm" : ""
            }`}
          >
            {searchField ? (
              <BsSearch
                onClick={() => handleSearchClick?.()}
                style={{ cursor: "pointer" }}
              />
            ) : (
              endIcon
            )}
          </span>
        </div>
      )}
    </div>
  );
};

TextField.propTypes = {
  type: PropTypes.string,
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  id: PropTypes.string,
  placeholder: PropTypes.string,
  labelClassName: PropTypes.string,
  containerClassName: PropTypes.string,
  state: PropTypes.oneOf(enums.inputFieldStates),
  className: PropTypes.string,
  style: PropTypes.object,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
  hasError: PropTypes.bool,
  rows: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  startIcon: PropTypes.node,
  endIcon: PropTypes.node,
  onChange: PropTypes.func,
  maxLength: PropTypes.string,
  size: PropTypes.oneOf(enums.componentSizes),
  searchField: PropTypes.bool,
};

TextField.defaultProps = {
  state: "default",
  type: "text",
  required: true,
};

export default TextField;
